enum IntercomProductTourTargets {
    SidebarHome = 'main-nav-home',
    SidebarCampaignsLink = 'main-nav-campaigns',
    SidebarTransactionsLink = 'main-nav-transactions',
    SidebarContactsLink = 'main-nav-contacts',
    SidebarEngageLink = 'main-nav-engage',
    SidebarPayoutsLink = 'main-nav-payouts',
    SidebarSettingsLink = 'main-nav-settings',
    SidebarWorkflowsLink = 'main-nav-workflows',
    SidebarHygieneLink = 'main-nav-hygiene',
    SidebarTasksLink = 'main-nav-tasks',
    SidebarReportsLink = 'main-nav-reports',
    SidebarNewCampaignsButton = 'main-nav-new-campaign',
    SidebarQuickActionsMenu = 'main-nav-action-menu',
    SidebarPlusContainer = 'main-nav-plus',
    SidebarPlusTitle = 'main-nav-plus-title',
    SidebarPinnedContainer = 'main-nav-pinned',
    SidebarPinnedTitle = 'main-nav-pinned-title',
    //
    HeaderUserMenu = 'header-user-menu',
    HeaderHelp = 'header-help',
    HeaderTasks = 'header-tasks',
    HeaderSearch = 'header-search',
    //
    TransactionsRecurringPlansSubnavTab = 'transactions-sub-nav-recurring',
    TransactionsPledgesSubnavTab = 'transactions-sub-nav-pledges',
    TransactionsSegments = 'transactions-segments',
    TransactionsFilters = 'transactions-filters',
    //
    ContactsSegments = 'contacts-segments',
    ContactsFilters = 'contacts-filters',
    ContactsDataHygieneSubnavTab = 'contacts-sub-nav-data-hygiene',
    //
    CampaignsSegments = 'campaigns-segments',
    CampaignsFilters = 'campaigns-filters',
    CampaignPinnedButton = 'campaign-settings-pinned-button',
    CampaignAuctionsTab = 'campaign-auctions-tab',
    CampaignToolsMatchesTitle = 'campaign-tools-matches-title',
    //
    WorkflowsNewWorkflowButton = 'workflows-new-workflow',
    //
    ReportsNewReportButton = 'reports-new-report',
    //
    TasksHeader = 'tasks-header',
    TasksSearch = 'tasks-search',
    //
    EngageSettingsSubnavTab = 'engage-sub-nav-settings',
    //
    SettingsImportsSubnavTab = 'settings-sub-nav-imports',
    //
    FiltersAddMoreButton = 'add-filter-button',
    //
    AuctionGettingStartedButton = 'auction-getting-started-button',
    AuctionSettingsSubnav = 'auction-settings-subnav',
    AuctionSettingsTitle = 'auction-settings-title',
    AuctionSettingsBiddingMethod = 'auction-settings-bidding-method',
    AuctionNotificationsSubnav = 'auction-notifications-subnav',
    AuctionNotificationsTitle = 'auction-notifications-title',
    AuctionItemsSubnav = 'auction-items-subnav',
    AuctionItemsTitle = 'auction-items-title',
    AuctionBiddersSubnav = 'auction-bidders-subnav',
    AuctionBiddersTitle = 'auction-bidders-title',
    AuctionWinningBidsSubnav = 'auction-winningbids-subnav',
    AuctionWinningBidsTitle = 'auction-winningbids-title',
    AuctionFulfillmentSubnav = 'auction-fulfillment-subnav',
    AuctionFulfillmentTitle = 'auction-fulfillment-title',
    //
    GlobalSearchFilter = 'global-search-filter',
    //
    PayoutsSettingsSubnav = 'payouts-sub-nav-settings',
}

export { IntercomProductTourTargets };
